import { isMobileQuery, getFeatureEnabled, ipCountryQuery, configQuery } from '@gig/magic-common';
import { BREAKPOINT_DEVICE_UPDATED, USER_LOGGED_IN_UPDATED, GAMEPLAY_BLOCK_LAUNCH_QUERY, GAMEPLAY_SIDENAV_QUERY, GAMEPLAY_SIDENAV_UPDATED, GAMEPLAY_BLOCK_LAUNCH_UPDATED, Feature } from '@gig/magic-messages';
import { __awaiter, __generator } from 'tslib';

var GameplayService = /** @class */ (function () {
    function GameplayService() {
        this.isMobile = false;
        this.loggedIn = false;
        this.registerSchemas();
        this.subscribeToSideNavChanges();
        this.subscribeToBlockLaunchChanges();
    }
    GameplayService.prototype.subscribeToSideNavChanges = function () {
        var _this = this;
        window.eventBus.subscribe([BREAKPOINT_DEVICE_UPDATED, USER_LOGGED_IN_UPDATED], function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, isMobileQuery()];
                    case 1:
                        _a.isMobile = _d.sent();
                        this.loggedIn = (_c = (_b = event.payload) === null || _b === void 0 ? void 0 : _b[1]) !== null && _c !== void 0 ? _c : false;
                        return [4 /*yield*/, this.updateSideNav()];
                    case 2:
                        _d.sent();
                        return [2 /*return*/];
                }
            });
        }); }, { replay: true });
    };
    GameplayService.prototype.subscribeToBlockLaunchChanges = function () {
        var _this = this;
        window.eventBus.subscribe(USER_LOGGED_IN_UPDATED, function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loggedIn = (_a = event.payload) !== null && _a !== void 0 ? _a : false;
                        return [4 /*yield*/, this.updateBlockLaunch()];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); }, { replay: true });
        window.queryBus.subscribe(GAMEPLAY_BLOCK_LAUNCH_QUERY, function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.shouldBlockLaunch()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); });
        window.queryBus.subscribe(GAMEPLAY_SIDENAV_QUERY, function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.shouldEnableSideNav()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); });
    };
    GameplayService.prototype.updateSideNav = function () {
        return __awaiter(this, void 0, void 0, function () {
            var enabled;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.shouldEnableSideNav()];
                    case 1:
                        enabled = _a.sent();
                        window.eventBus.publish(GAMEPLAY_SIDENAV_UPDATED, enabled);
                        return [2 /*return*/];
                }
            });
        });
    };
    GameplayService.prototype.updateBlockLaunch = function () {
        return __awaiter(this, void 0, void 0, function () {
            var shouldBlock;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.shouldBlockLaunch()];
                    case 1:
                        shouldBlock = _a.sent();
                        window.eventBus.publish(GAMEPLAY_BLOCK_LAUNCH_UPDATED, shouldBlock);
                        return [2 /*return*/];
                }
            });
        });
    };
    GameplayService.prototype.shouldEnableSideNav = function () {
        return __awaiter(this, void 0, void 0, function () {
            var quickDepositEnabled;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getFeatureEnabled(Feature.QUICK_DEPOSIT)];
                    case 1:
                        quickDepositEnabled = _a.sent();
                        return [2 /*return*/, quickDepositEnabled && this.isMobile && this.loggedIn];
                }
            });
        });
    };
    GameplayService.prototype.shouldBlockLaunch = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, countries, ipCountry;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.loggedIn) {
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, Promise.all([
                                this.getBlockedLaunchCountries(),
                                ipCountryQuery(),
                            ])];
                    case 1:
                        _a = _b.sent(), countries = _a[0], ipCountry = _a[1];
                        return [2 /*return*/, countries.includes(ipCountry)];
                }
            });
        });
    };
    GameplayService.prototype.getBlockedLaunchCountries = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, configQuery('gamePlay.playForFunBlockedCountriesWithInfo')];
                    case 1: return [2 /*return*/, ((_a = (_b.sent())) !== null && _a !== void 0 ? _a : [])];
                }
            });
        });
    };
    GameplayService.prototype.registerSchemas = function () {
        window.eventBus.register(GAMEPLAY_SIDENAV_UPDATED, {
            type: 'boolean',
        });
        window.eventBus.register(GAMEPLAY_BLOCK_LAUNCH_UPDATED, {
            type: 'boolean',
        });
    };
    return GameplayService;
}());

export { GameplayService };
